<template>
  <div>
    <a-skeleton :loading="loadingItem" :paragraph="{ rows: 6 }">
      <div>
        <a-form-model
          ref="form"
          :model="form"
          :rules="rules"
          style="overflow-y: auto;"
        >
          <a-form-model-item has-feedback label="Họ và tên" prop="fullname">
            <a-input
              v-model="form.fullname"
              placeholder="Nhập đầy đủ họ và tên"
            />
          </a-form-model-item>
          <a-form-model-item
            label="Admin of location / Admin của chi nhánh này"
          >
            <SelectBranchLocation
              v-model="form.adminOfLocationId"
              :selectProps="{
                value: form.adminOfLocationId || undefined,
                style: { width: '100%' },
                placeholder: 'Admin of location',
              }"
            />
          </a-form-model-item>
          <a-form-model-item has-feedback label="Email" prop="email">
            <a-input v-model="form.email" placeholder="Nhập email" disabled />
          </a-form-model-item>
          <a-form-model-item
            has-feedback
            label="Direct manager"
            prop="directManagerId"
          >
            <span class="text-info">
              {{
                form.directManager &&
                form.directManager.username &&
                form.directManager.fullname
              }}</span
            >
            <SelectChoiceUser v-model="form.directManagerId" />
          </a-form-model-item>
          <a-form-model-item label="Status">
            <a-checkbox v-model="form.status">
              Active
            </a-checkbox>
          </a-form-model-item>
        </a-form-model>
        <div
          style="text-align: right;"
          :style="{
            position: 'absolute',
            right: 0,
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e9e9e9',
            padding: '10px 16px',
            background: '#fff',
            textAlign: 'right',
            zIndex: 1,
          }"
        >
          <!--          <a-popconfirm-->
          <!--            title="Xác nhận muốn xóa nhân viên."-->
          <!--            ok-text="Có"-->
          <!--            cancel-text="Không"-->
          <!--            @confirm="-->
          <!--              () => {-->
          <!--                this.loadingDelete = true;-->
          <!--                deleteEmployee();-->
          <!--              }-->
          <!--            "-->
          <!--            style="float: left;"-->
          <!--          >-->
          <!--            <a-button type="danger" icon="delete" :loading="loadingDelete">-->
          <!--              Xóa-->
          <!--            </a-button>-->
          <!--          </a-popconfirm>-->
          <a-button
            @click="closeDrawerUpdateEmployee"
            style="margin-right: 5px;"
          >
            Đóng
          </a-button>
          <a-button
            type="primary"
            @click="updateUser"
            icon="save"
            :loading="loadingUpdate"
          >
            Lưu
          </a-button>
        </div>
      </div>
    </a-skeleton>
  </div>
</template>
<script>
import moment from "moment";
import postQuery, { queryUpdateUser } from "../../data/postData";
import SelectChoiceUser from "./selectChoiceUser";
import SelectBranchLocation from "@/components/common/branchLocation/select";

export default {
  components: { SelectChoiceUser, SelectBranchLocation },
  props: {
    updateEmployeeOnView: {
      type: Function,
      default: null,
    },
    closeDrawerUpdateEmployee: {
      type: Function,
      default: null,
    },
    formEmployee: {
      type: Object,
      default: null,
    },
    loadingItem: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    let checkCode = (rule, value, callback) => {
      if (!this.regCode.test(this.form.code)) {
        callback(
          new Error(
            "Mã nhân viên yêu cầu tối thiểu 4 ký tự, không được trùng, không dấu cách, không dấu,ký tự đặc biệt trừ dấu _"
          )
        );
      } else {
        callback();
      }
    };
    let checkEmail = (rule, value, callback) => {
      if (!this.regEmail.test(this.form.email)) {
        if (this.form.email) {
          callback(
            new Error(
              "Email này không hợp lệ. Hãy đảm bảo rằng email được nhập dưới dạng example@email.com"
            )
          );
        } else {
          callback();
        }
      } else {
        callback();
      }
    };

    return {
      rules: {
        code: [
          {
            required: true,
            message: "Mã nhân viên không được bỏ trống",
            trigger: "change",
          },
          { validator: checkCode, trigger: "change" },
        ],

        email: [{ validator: checkEmail, trigger: "change" }],
        fullname: [
          {
            required: true,
            message: "Họ và tên không được bỏ trống",
            trigger: "change",
          },
        ],
      },
      form: {},
      loadingDeleteUser: false,
      loadingDelete: false,
      loadingUpdate: false,
      regEmail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      regCode: /^\w{4,100}$/,
    };
  },
  methods: {
    moment,
    updateUser() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loadingUpdate = true;
          // this.changeDataFormWhenPost();
          this.$apollo
            .mutate({
              mutation: queryUpdateUser,
              variables: {
                fullname: this.form.fullname,
                adminOfLocationId: this.form.adminOfLocationId || null,
                directManagerId: this.form.directManagerId || null,
                id: this.form.id,
                status: this.form.status ? "ACTIVE" : "DEACTIVE",
              },
            })
            .then(({ data }) => {
              if (data?.updateUser) {
                this.$notification.success({
                  message: "Thông báo",
                  description: "Cập nhật User thành công",
                });
                this.closeDrawerUpdateEmployee();
                this.updateEmployeeOnView(data.updateUser);
              }
              this.loadingUpdate = false;
            })
            .catch((error) => {
              this.$notification.error({
                message: "Thông báo",
                description: "Cập nhật User thất bại",
              });
              console.log("Không cập nhật được nhân viên", error);
              this.loadingUpdate = false;
            });
        } else {
          return false;
        }
      });
    },
    deleteEmployee() {
      this.loadingDelete = true;
      this.$apollo
        .mutate({
          mutation: postQuery.queryDeleteEmployee,
          variables: {
            id: this.formEmployee.id,
          },
        })
        .then((data) => {
          this.$notification.success({
            message: "Thông báo",
            description: "Xóa nhân viên thành công",
          });
          this.loadingDelete = false;
          this.$router.push({ name: "employee" });
        })
        .catch((error) => {
          this.loadingDelete = false;
          this.$notification.error({
            message: "Thông báo",
            description: "Xóa nhân viên không thành công",
          });
          console.log("Xóa nhân viên không thành công", error);
        });
    },
  },
  created() {
    this.form = {
      ...this.formEmployee,
      userId: this.formEmployee.userId ? this.formEmployee.userId : undefined,
      positionId: this.formEmployee.positionId || null,
      directManagerId: this.formEmployee.directManagerId || null,
      departmentId: this.formEmployee.departmentId || null,
      adminOfLocationId: this.formEmployee.adminOfLocationId || null,
    };
  },
};
</script>
